import { useEffect, useRef, useState } from "react"
import { SecurityCodeMethod, useMfaApi } from "../../mfa/hooks/useMfaApi";

export interface MfaOption {
    id: string;
    type: SecurityCodeMethod;
    mfa_channel: string
}

export const useSetConfigurationOptions = () => {
    const [options, setOptions] = useState<MfaOption[] | null>(null);
    const api = useMfaApi();
    const ref = useRef(false);

    useEffect(() => {
        if (ref.current) {
            return;
        }
        setConfigurationOptions();
        async function setConfigurationOptions() {
            ref.current = true;
            const optionsResponse = await api.mfaGetOptions();
            if (optionsResponse?.status !== 200) {
                setOptions([]);
                return;
            }
            setOptions(optionsResponse.data.configured_options);
        }
    }, [api]);

    return options;
}